<template>
  <div class="container-page">
    <p class="title-inner">Карточка создания мероприятия</p>
    <EventCardAddContent
      :showSwitch="true"
      :showPublicUrl="true"
      :assignmentId="assignmentId"
      :defaultCountryId="defaultCountryId"
      @saved="onSaved"
      @cancel="close"
    />
  </div>
</template>

<script>
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import EventCardAddContent from '@/modules/mpk/components/EventCardAddContent.vue';

  //const selectValidator = (value) => value > 0;

  export default {
    name: 'EventCardAdd',
    components: {
      EventCardAddContent,
    },
    mixins: [security],
    data() {
      return {
        defaultCountryId: null,
        assignmentId: null,
      };
    },
    async created() {
      await this.checkPermissionAndRedirect(Constants.Permissions.MpkEventsEdit);

      if (this.$route.query && this.$route.query.countryId > 0) {
        this.defaultCountryId = this.$route.query.countryId;
      }

      this.checkAssignmentFromRoute();
    },
    methods: {
      checkAssignmentFromRoute() {
        if (this.$route.query && this.$route.query.assignmentId) {
          this.assignmentId = Number(this.$route.query.assignmentId);
        }
      },

      onSaved(response) {
        if (this.assignmentId) {
          this.$router.push({
            path: '/ZaMer/Orders',
            query: {
              assignmentIdFromEvent: this.assignmentId,
            },
          });
        } else {
          this.$router.push({
            path: '/Mpk/Events',
            query: {
              countryId: response.countryId,
            },
          });
        }
      },
      close() {
        if (this.assignmentId) {
          this.$router.push({
            path: '/ZaMer/Orders',
            query: {
              assignmentIdFromEvent: this.assignmentId,
            },
          });
        } else {
          this.$router.push({ name: 'Events' });
        }
      },
    },
  };
</script>
